module.exports = __webpack_public_path__ + "static/material-denim.e795da9c.svg";